<nav
  class="rtl md:right-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-blueGray-800 flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
  <div
    class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
    <!-- Brand -->
    <a [routerLink]="['/admin/dashboard']"
      class="flex text-right md:pb-2 text-white mr-0 cursor-pointer text-2xl uppercase z-100 font-semibold p-4 px-0">
      <img src="../../../assets/img/Ostadvisit-Logo.svg" class="w-10" alt="">
      <span class="block sm:hidden m-2"> {{'OstadVisit'|translate}} </span>
      <span class="hidden sm:block m-2"> {{'OstadVisit'|translate}} </span>
    </a>
    <!-- Toggler -->
    <button
      class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
      type="button" (click)="toggleCollapseShow('bg-blueGray-800 m-2 py-3 px-6')">
      <i class="fas fa-bars"></i>
    </button>
    <div
      class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
      [ngClass]="collapseShow">
      <!-- Collapse header -->
      <div class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
        <div class="flex flex-wrap">
          <div class="w-6/12">
            <a [routerLink]="['/']"
              class="md:block text-left md:pb-2 text-white mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0">
              {{'OstadVisit'|translate}}
            </a>
          </div>
          <div class="w-6/12 flex justify-end">
            <button type="button"
              class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              (click)="toggleCollapseShow('hidden')">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="my-4 md:min-w-full" />
      <!-- Navigation -->

      <ul class="md:flex-col md:min-w-full flex flex-col list-none">
        <li class="items-center"><a [routerLink]="['/admin/visits']" class="text-base p-3 font-bold flex rounded-lg"
            routerLinkActive #userAppointment="routerLinkActive" [ngClass]="
            userAppointment.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-9"
              [src]="userAppointment.isActive?'../../../assets/img/icon/card-tick-v2.svg':'../../../assets/img/icon/card-tick.svg'"
              alt="">
            ویزیت ها </a>
        </li>
        <li class="items-center"><a [routerLink]="['/admin/doctors']"
            class="text-base uppercase p-3 font-bold rounded-lg flex" routerLinkActive #userAccount="routerLinkActive"
            [ngClass]="
            userAccount.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10"
              [src]="userAccount.isActive?'../../../assets/img/icon/doctor-v2.svg':'../../../assets/img/icon/doctor.svg'"
              alt="">
            {{'General.DoctorsList'|translate}} </a></li>

        <li class="items-center"><a [routerLink]="['/admin/users']" (click)="toggleSubmenu('users')"
            class="text-base uppercase p-3 font-bold flex rounded-lg" routerLinkActive #users="routerLinkActive"
            [ngClass]="
                users.isActive
                  ? 'text-primary hover:text-primary bg-primary-light'
                  : 'text-white hover:text-blueGray-500'
              ">
            <img class="px-2 mx-1 w-10"
              [src]="users.isActive?'../../../assets/img/icon/people-v2.svg':'../../../assets/img/icon/people.svg'"
              alt="">
            {{'General.Users'|translate}} </a>

          <!-- Submenu -->
          <ul *ngIf="submenuOpen === 'users'" class="ml-6">
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/users/users-list']" routerLinkActive #userlist="routerLinkActive" [ngClass]=" userlist.isActive ? 'text-primary'
                  : ' text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.UsersList'|translate}}
              </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/users/comments']" routerLinkActive #comments="routerLinkActive" [ngClass]=" comments.isActive ? 'text-primary'
                  : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm ">
                {{'General.UsersComments'|translate}} </a>
            </li>
          </ul>
        </li>

        <li class="items-center"><a [routerLink]="['/admin/category']" (click)="toggleSubmenu('category')"
          class="text-base uppercase p-3 font-bold flex rounded-lg" routerLinkActive #category="routerLinkActive"
          [ngClass]="
        category.isActive
          ? 'text-primary hover:text-primary bg-primary-light'
          : 'text-white hover:text-blueGray-500'
      ">
          <img class="px-2 mx-1 w-9"
            [src]="category.isActive?'../../../assets/img/icon/category-v2.svg':'../../../assets/img/icon/category.svg'"
            alt="">
          {{'General.MedicalCategory'|translate}} </a>

        <!-- Submenu -->
        <ul *ngIf="submenuOpen === 'category'" class="ml-6">
          <li class="py-2 px-12">
            <a [routerLink]="['/admin/category/medical-category']" routerLinkActive #cat="routerLinkActive" [ngClass]=" cat.isActive ? 'text-primary'
            : ' text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.AddCategory'|translate}} </a>
          </li>
          <li class="py-2 px-12">
            <a [routerLink]="['/admin/category/sub-category']" routerLinkActive #subCat="routerLinkActive" [ngClass]=" subCat.isActive ? 'text-primary'
            : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm ">
              {{'General.AddSubCategory'|translate}} </a>
          </li>
          <li class="py-2 px-12">
            <a [routerLink]="['/admin/category/tariff']" routerLinkActive #tarrifs="routerLinkActive" [ngClass]=" tarrifs.isActive ? 'text-primary'
            : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
              {{'General.Tarrifs'|translate}} </a>
          </li>
          <li class="py-2 px-12">
            <a [routerLink]="['/admin/category/tariff-category']" routerLinkActive #tarrif="routerLinkActive" [ngClass]=" tarrif.isActive ? 'text-primary'
            : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.TarrifAllocation'|translate}} </a>
          </li>
        </ul>
      </li>

        <li class="items-center"><a [routerLink]="['/admin/financial']" (click)="toggleSubmenu('finan')"
            class="text-base uppercase p-3 font-bold rounded-lg flex" routerLinkActive #userWallet="routerLinkActive"
            [ngClass]="
            userWallet.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-9"
              [src]="userWallet.isActive?'../../../assets/img/icon/empty-wallet-v2.svg':'../../../assets/img/icon/empty-wallet.svg'"
              alt="">
            مدیریت مالی </a>
          <!-- Submenu -->
          <ul *ngIf="submenuOpen === 'finan'" class="ml-6">
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/financial/transactions']" routerLinkActive #transactions="routerLinkActive" [ngClass]=" transactions.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                تراکنشات </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/financial/requests']" routerLinkActive #finanRequests="routerLinkActive" [ngClass]=" finanRequests.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                درخواست ها </a>
            </li>
          </ul>
        </li>
        <li class="items-center"><a [routerLink]="['/admin/message']"
            class="text-base uppercase p-3 font-bold flex rounded-lg" routerLinkActive #message="routerLinkActive"
            [ngClass]="
            message.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-white hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-9"
              [src]="message.isActive?'../../../assets/img/icon/message-text-v2.svg':'../../../assets/img/icon/message-text.svg'"
              alt="">
             {{'General.Messages'|translate}} </a>
        </li>

        <li class="items-center"><a [routerLink]="['/admin/content']" (click)="toggleSubmenu('content')"
            class="text-base uppercase p-3 font-bold flex rounded-lg" routerLinkActive #content="routerLinkActive"
            [ngClass]="
          content.isActive
            ? 'text-primary hover:text-primary bg-primary-light'
            : 'text-white hover:text-blueGray-500'
        ">
            <img class="px-2 mx-1 w-9"
              [src]="content.isActive?'../../../assets/img/icon/Document-v2.svg':'../../../assets/img/icon/Document.svg'"
              alt="">
            {{'General.Content'|translate}} </a>

          <!-- Submenu -->
          <ul *ngIf="submenuOpen === 'content'" class="ml-6">
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/content/blog']" routerLinkActive #blog="routerLinkActive" [ngClass]=" blog.isActive ? 'text-primary'
              : ' text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.Blogs'|translate}} </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/content/question']" routerLinkActive #question="routerLinkActive" [ngClass]=" question.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm ">
                {{'General.FrequentlyQuestions'|translate}} </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/content/about']" routerLinkActive #about="routerLinkActive" [ngClass]=" about.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.AboutUs'|translate}} </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/content/terms']" routerLinkActive #terms="routerLinkActive" [ngClass]=" terms.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.Terms'|translate}} </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/content/privacy']" routerLinkActive #privacy="routerLinkActive" [ngClass]=" privacy.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm"> {{'General.Privacy'|translate}} </a>
            </li>
          </ul>
        </li>

        <li class="items-center"><a [routerLink]="['/admin/settings']" (click)="toggleSubmenu('setting')"
            class="text-base uppercase p-3 font-bold flex rounded-lg" routerLinkActive #set="routerLinkActive"
            [ngClass]="
        set.isActive
          ? 'text-primary hover:text-primary bg-primary-light'
          : 'text-white hover:text-blueGray-500'
      ">
            <img class="px-2 mx-1 w-9"
              [src]="set.isActive?'../../../assets/img/icon/setting-2-v2.svg':'../../../assets/img/icon/setting-2.svg'"
              alt="">
            {{'General.Setting'|translate}} </a>

          <!-- Submenu -->
          <ul *ngIf="submenuOpen === 'setting'" class="ml-6">
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/settings/site-setting']" routerLinkActive #siteInfo="routerLinkActive" [ngClass]=" siteInfo.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                اطلاعات سایت </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/settings/site-incomes']" routerLinkActive #income="routerLinkActive" [ngClass]=" income.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                درآمد سایت </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/settings/cancel-rules']" routerLinkActive #cancleRule="routerLinkActive" [ngClass]=" cancleRule.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                قوانین کنسل کردن </a>
            </li>
            <!-- <li class="py-2 px-12">
              <a [routerLink]="['/admin/settings/languages']" routerLinkActive #languages="routerLinkActive" [ngClass]=" languages.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                {{'General.Languages'|translate}} </a>
            </li>
            <li class="py-2 px-12">
              <a [routerLink]="['/admin/settings']" routerLinkActive #credit="routerLinkActive" [ngClass]=" credit.isActive ? 'text-primary'
              : 'text-blueGray-200 hover:text-blueGray-300'" class="text-sm">
                {{'General.CreditStatus'|translate}} </a>
            </li> -->
          </ul>
        </li>

        <li class="items-center"><a routerlinkactive="" (click)="modal.open()"
            class="text-base uppercase p-3 font-bold flex text-white hover:text-blueGray-500">
            <img class="px-2 mx-1 w-9" src="../../../assets/img/icon/logout.svg" alt="">
            {{'General.Logout'|translate}} </a>
          </li>
      </ul>

      <app-modal #modal>
        <!--header-->
        <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
          <h3 class="text-2xl font-semibold">
            خروج
          </h3>
          <button
            class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
            (click)="modal.close()">
            <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
              ×
            </span>
          </button>
        </div>
        <!--body-->
        <div class="relative p-6 flex-auto">
          <p class="mt-4 mb-12 text-blueGray-500 text-base text-start leading-relaxed">
            آیا قصد دارید از پنل مدیریت خارج شوید؟
          </p>
        </div>
        <!--footer-->
        <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
          <button
            class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
            type="button" (click)="modal.close()">
            انصراف
          </button>
          <button
            class="bg-red-500 text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
            type="button" (click)="logout()">
            خروج
          </button>
        </div>
      </app-modal>

    </div>
  </div>
</nav>